AFRAME.registerComponent("background-transition", {
  schema: {
    environmentEl: { type: "selector" }
  },
  init() {
    this.opacity = 0;
    this.transitioning = false;
  },
  transition() {
    const mesh = this.el.getObject3D("mesh");

    if (mesh) {
      mesh.traverse(node => {
        if (node.material) {
          node.material.transparent = true;
          node.material.opacity = 0;
          node.material.needsUpdate = true;
        }
      });

      this.transitioning = true;
    }
  },
  tick() {
    if (this.transitioning) {
      this.opacity += 0.02;

      const mesh = this.el.getObject3D("mesh");

      mesh.traverse(node => {
        if (node.material) {
          if (this.opacity >= 1) {
            node.material.transparent = false;
          }

          node.material.opacity = this.opacity;
          node.material.needsUpdate = true;
        }
      });

      if (this.opacity >= 1) {
        this.transitioning = false;
        this.opacity = 0;
        // remove the previous environment scene
        // const environmentScene = this.data.environmentEl.parentNode;
        // environmentScene.removeChild(environmentScene.childNodes[0]);

        // handle visible/invisible avatars between transitions of portals
        const tourHandlers = document.querySelectorAll("[avatar-tour-handler]");
        setTimeout(() => {
          tourHandlers.forEach(handler => {
            handler.components["avatar-tour-handler"].checkTour();
          });
        }, 60)        
      }
    }
  }
});
